import React, { useEffect } from "react";
import "./examSection.css";
import { Link } from "react-router-dom";

import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Helpers from "../helpers/Helpers";
import ServicesCard from "../servicesCard/ServicesCard";
import ModernServicesCard from "../modernServiceCard/ModernServicesCard";
// import { useLocation } from "react-router-dom";

const squareVariantsX = {
  visible: { opacity: 1, y: 0, transition: { duration: 2 } },
  hidden: { opacity: 0, y: 100 },
};

const ExamSection = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);
  return (
    <div className="examProfContFamGenn">
      <div className="cloud_down">
        <img src={Helpers.cloud_down} />
      </div>
      <div className="examProfContHead">
        <h2>Departments</h2>
      </div>
      <motion.div
        ref={ref}
        animate={controls}
        initial="hidden"
        variants={squareVariantsX}
        className="examProfContFamm"
      >
        <div className="examProfContEach">
          <ModernServicesCard
            serviceCardImg={Helpers.creche}
            serviceHead="CRECHE & NURSERY"
            serviceText="TO DEVELOP THE TOTAL CHILD"
            serviceSubText="9, Adebisi Adedire Baale Bus Stop, Meiran, Lagos State."
            portalUrl="https://jcard.icrystal.org.ng/mySchool_login?cboSchool=TRIUMPHANT%20JUMAK%20NURSERY/PRIMARY%20SCHOOL
"
          />
        </div>
        <div className="examProfContEach">
          <ModernServicesCard
            serviceCardImg={Helpers.primary}
            serviceHead="PRIMARY"
            serviceText="UNIVERSAL BASIC EDUCATION"
            serviceSubText="9, Adebisi Adedire Baale Bus Stop, Meiran, Lagos State."
            portalUrl="https://jcard.icrystal.org.ng/mySchool_login?cboSchool=TRIUMPHANT%20JUMAK%20NURSERY/PRIMARY%20SCHOOL
"
          />
        </div>
        <div className="examProfContEach">
          <ModernServicesCard
            serviceCardImg={Helpers.secondary}
            serviceHead="COLLEGE"
            serviceText="GOVERNMENT APPROVED INSTITUTION"
            serviceSubText="43, Ademola Abogunrin Omolayo Bus Stop, Meiran, Lagos State."
            portalUrl="https://jcard.icrystal.org.ng/mySchool_login?cboSchool=TRIUMPHANT%20JUMAK%20COMPREHENSIVE%20COLLEGE"
          />
        </div>
      </motion.div>
    </div>
  );
};

export default ExamSection;
